import { z } from 'zod'
import type { AlertEvent } from './alert-types'

/**
 * Which scanner events the Alert Log lists. Display only: audibility stays
 * fixed (added tickers alert, removed ones log silently), so this never
 * changes what plays.
 */
export const alertLogShowSchema = z.enum(['all', 'added', 'removed'])
export type AlertLogShow = z.infer<typeof alertLogShowSchema>

export const ALERT_LOG_SHOW_OPTIONS: { value: AlertLogShow; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'added', label: 'Added' },
  { value: 'removed', label: 'Removed' },
]

/** This scan's events, narrowed to the chosen action. */
export function scanAlertLog(
  events: AlertEvent[],
  scanId: string,
  show: AlertLogShow,
): AlertEvent[] {
  return events.filter((e) => e.scanId === scanId && (show === 'all' || e.action === show))
}
